// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ybQZg3FGpuIQPgZbQIh8{padding:0 7px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ybQZg3FGpuIQPgZbQIh8`
};
export default ___CSS_LOADER_EXPORT___;
